@if (labelTitle) {
  <sd-form-libelle
    [idField]="'select-' + uuidInput"
    [idLabel]="'label-' + uuidInput"
    [labelHidden]="labelHidden"
    [labelTitle]="labelTitle"
    [required]="required"
  />
}

<select
  [name]="nameField"
  [id]="'select-'+uuidInput"
  [required]="required"
  #select
  [class]="{'is-disabled': internalField.disabled}"
  (change)="mobileSelection(select)"
  [formControl]="internalField"
>
  @if (placeholder) {
    <option value="">{{ placeholder }}</option>
  }
  @for (item of items; track $index) {
    <option
      [value]="item[valueKey]"
      tabindex="1"
      [selected]="item[libelleKey] === internalField.value?.label"
    >
      {{ item[libelleKey] }}
    </option>
  }
</select>

<sd-dropdown
  [brand]="brand"
  [isBtnSmall]="isSmall"
  [labeledBy]="'label-'+uuidInput"
  [type]="dropdownType"
  [isSelected]="internalField.value"
  dropdownCustomClass="is-select-menu"
  [(isOpened)]="isOpened"
  [disabled]="internalField.disabled"
  [readonly]="readonly"
  [attr.title]="_libelle"
  (isOpenedChange)="isOpenedChange.emit($event)"
  (buttonSize)="buttonSize = $event"
>
  <ng-container sd-dropdown-button>
    {{ _libelle }}
  </ng-container>

  @if (hasAutocomplete) {
    <sd-form autocomplete
      sd-dropdown-menu
      (formChange)="onChange($event)"
      [displayWidth]="displayWidth"
      [maxDisplayedResults]="-1"
      classField="c__input"
      [optionsAreCheckboxes]="false"
      [isSelect]="true"
      [elements]="items"
      [properties]="['label']"
      [valueKey]="valueKey"
      [libelleKey]="libelleKey"
      [libelle]="_libelle"
      [minLength]="0"
    />
  }

  @if (!hasAutocomplete) {
    <ul
      class="c__content {{isSmall ? 'is-small' : ''}}"
      sd-list-block sd-dropdown-menu sdUpDown
      role="listbox"
      [style.width.px]="buttonSize"
    >
      @for (item of items; track $index) {
        <li class="c__option"
          [attr.tabindex]="isFocusable ? '1' : '-1'"
          role="option"
          [attr.data-value]="item[valueKey]"
          [attr.aria-selected]="item[libelleKey] === _libelle"
          (keydown.enter)="itemClickSelected(item, $event)"
          (click)="itemClickSelected(item)"
        >
          {{ item[libelleKey] }}
        </li>
      }
    </ul>
  }
</sd-dropdown>

<ng-content select="[sd-message]" />
